<template>
  <a-modal :title="title" :visible="visible" @ok="ok" @cancel="cancel" okText="确定" cancelText="取消" destroyOnClose :maskClosable="false" width="1100px">
    <div class="raw-model-info-row">
      已选中配方：
      <span>{{ formulaSelectedRows.map((item) => `【${item.formulaName}】`).join(',') }}</span>
    </div>
    <div class="raw-model-info-row">可修改原料明细：</div>
    <a-button @click="addList" type="primary" style="margin-bottom: 10px">导入</a-button>

    <a-table ref="listRef" :columns="columns" :data-source="list" :pagination="false" :scroll="{ y }" row-key="id">
      <template slot-scope="text" slot="name">
        <a-tooltip>
          <template slot="title">
            {{ text }}
          </template>
          {{ text }}
        </a-tooltip>
      </template>
      <template slot-scope="text, record" v-for="(col, i) in ['minValue', 'maxValue']" :slot="col">
        <span :key="i">
          <cell-editor :background="true" :item="record" :len="3" :name="col" @blur="(target) => itemUpdate(target, record, col)" :text="text" />
        </span>
      </template>
      <template slot="x" slot-scope="text, record, i">
        <a-button type="link" @click="() => deleteRow(i)">删除</a-button>
      </template>
    </a-table>
    <all-material-list :visible="allMaterialVisible" @close="closeAll" :addIds="addIds" :formulaIdList="formulaIdList" />
  </a-modal>
</template>

<script>
import CellEditor from '@/components/Common/components/CellEditor.vue';
import AllMaterialList from './AllMaterialListEdit.vue';
export default {
  props: ['visible', 'formulaIdList', 'formulaSelectedRows'],
  components: { CellEditor, AllMaterialList },
  data() {
    return {
      allMaterialVisible: false,
      title: (
        <p>
          修改原料<span style="font-size: 12px;color: #999;font-weight: normal;margin-left: 10px;">修改配方中指定原料的约束条件</span>
        </p>
      ),
      list: [],
      y: 300,
      columns: [
        {
          title: '原料名称',
          dataIndex: 'rawName',
          width: 180,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '原料代码',
          dataIndex: 'rawCode',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '配方名称',
          dataIndex: 'formulaName',
          width: 140,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '配方代码',
          dataIndex: 'formulaCode',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '配方用量(%)',
          dataIndex: 'percentage',
          width: 100,
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(3);
          }
        },
        {
          title: '产品用量(%)',
          dataIndex: 'productRawPercentage',
          width: 100,
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(3);
          }
        },
        {
          title: '最小值',
          dataIndex: 'minValue',
          width: 100,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'minValue' },
        },
        {
          title: '最大值',
          dataIndex: 'maxValue',
          width: 100,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'maxValue' },
        },
        {
          title: '操作',
          dataIndex: 'x',
          width: 80,
          scopedSlots: { customRender: 'x' },
        },
      ],
      addIds: [],
    };
  },
  watch: {
    visible(val) {
      if (val) this.list = [];
    },
  },
  methods: {
    addList() {
      let lst = this.list.map((el) => el.rawId);
      this.addIds = lst || [];
      setTimeout(() => {
        this.allMaterialVisible = true;
      }, 0);
    },
    closeAll(val) {
      if (val) {
        this.list = [...this.list, ...val];
      }
      this.allMaterialVisible = false;
    },
    ok() {
      let data = {
        formulaIdList: this.formulaIdList,
        formulaRawList: this.list.map((el) => {
          return { id: el.id, maxValue: el.maxValue, minValue: el.minValue };
        }),
      };
      this.$http.post('/nhf-app/formulaManage/formulaRawBatchUpdate', data).then((res) => {
        let { success, msg } = res || {};
        let feild = 'warning';
        if (success) feild = 'success';
        this.$message[feild](msg);
        this.$emit('close', true);
      });
    },
    cancel() {
      this.$emit('close', false);
    },
    itemUpdate(target, record, col) {
      record[col] = target[col];
    },
    deleteRow(index) {
      this.list.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.raw-model-info-row {
  margin-bottom: 8px;

  span {
    color: #999;
  }
}

::v-deep .ant-modal-body {
  padding-top: 8px;
}
</style>
